import React, { useState } from 'react';
import { usePassportKindVisual } from '../passport/usePassportKindVisual';
import { vehicleSourceCard, type VehicleSource } from '../passport/sourceCards';
import type { PassportCard as Card } from '../../services/api/passportCards';
import PassportCard from '../passport/PassportCard';
import '../passport/collector-card.css';
import './build-collector-rail-card.css';

export interface BuildCollectorRailCardProps {
  source?: VehicleSource;
  isOwner?: boolean;
  title: string;
  year: number;
  make: string;
  model: string;
  trim?: string | null;
  imageUrl?: string | null;
  modificationCount: number;
  certificationStatus?: string | null;
  rarityStars?: number | null;
  className?: string;
  vehicleId: number;
  ownerUsername: string;
  publicSlug?: string | null;
  story?: string | null;
}

/**
 * Full Passport collectible for the build-page section rail.
 * PassportCard owns the hinge; this wrapper owns only selection and explicit controls.
 */
export default function BuildCollectorRailCard(props: BuildCollectorRailCardProps) {
  const [back, setBack] = useState(false);
  const visual = usePassportKindVisual('vehicle');
  const card = vehicleSourceCard(
    {
      id: props.vehicleId,
      owner_username: props.ownerUsername,
      public_slug: props.publicSlug || undefined,
      description: props.story || undefined,
      display_name: props.title,
      year: props.year,
      make: props.make,
      model: props.model,
      trim: props.trim || undefined,
      image_url: props.imageUrl || undefined,
      modification_count: props.modificationCount,
      certification_status: props.certificationStatus,
      ...props.source,
    },
    props.isOwner
  );
  if (visual) card.design.visual = visual;
  return (
    <BuildCollectorRailPresentation
      card={card}
      back={back}
      onBack={setBack}
      className={props.className}
    />
  );
}
/** Shared build-rail presentation used by the real profile and the internal context preview. */
export function BuildCollectorRailPresentation({
  card,
  back,
  onBack,
  className = '',
  demo = false,
}: {
  card: Card;
  back: boolean;
  onBack: (back: boolean) => void;
  className?: string;
  demo?: boolean;
}) {
  const title = card.title;
  const toggle = () => onBack(!back);

  return (
    <div
      className={`collector-card build-collector-rail-card ${className}`.trim()}
      data-side={back ? 'back' : 'front'}
    >
      <div className="build-collector-rail-card__stage">
        <PassportCard
          card={card}
          demo={demo}
          quiet
          back={back}
          readableStory={back}
          backLabel={`${title} build record`}
          onFlip={toggle}
        />
      </div>
    </div>
  );
}
